import { HEALTH_APP_RESULTS } from "pages/PreQualification/utils/constants";
import FooterButton from "uicomponents/FooterButton";
import DeniedHIContent from "./DeniedHIContent";
import DeniedUpsellContent from "./DeniedUpsellContent";
import { getAppType, getCWRedirectUrl } from "utils/helper";
import styles from "../Results.module.css";

const ResultPageDeniedModel = (): JSX.Element => {
  const isHealthInsuranceUpsellApp = getAppType() === "HEALTH_INSURANCE_UPSELL";

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{HEALTH_APP_RESULTS.DENIED.title}</h3>
      {isHealthInsuranceUpsellApp ? (
        <DeniedUpsellContent />
      ) : (
        <DeniedHIContent />
      )}
      <FooterButton
        nextButtonText={HEALTH_APP_RESULTS.DENIED.nextButtonText}
        nextButtonHref={
          isHealthInsuranceUpsellApp
            ? getCWRedirectUrl("/benefits/offer")
            : getCWRedirectUrl("/onboarding_checklist")
        }
        hasOnlyNextButton
      />
    </div>
  );
};

export default ResultPageDeniedModel;
